import { IonCard, IonCardHeader, IonToolbar, IonCardTitle, IonButton, IonCardContent, IonLabel, IonItem, IonInput } from '@ionic/react';
import React, { useContext, useState } from 'react';
import { AppContext } from 'context/app.context';
import { AuthContext } from 'context/auth.context';
import { createNewVersion } from 'misc/phqHTTP';
import { PHQVersion } from 'models/questionnaire.model';
import { QuestionnaireActionTypes } from 'reducers/questionnaire.reducer';


const PHQPublishVersionForm = (props: {
    fnToHideForm: (published: boolean) => void
}) => {

    const authContext = useContext(AuthContext);
    const { questionnaire, notifySuccess, updateQuestionnaire, setIsLoading } = useContext(AppContext);
    const [description, setDescription] = useState<string>();

    const publishVersion = async () => {
        setIsLoading(true);

        const payload = new PHQVersion();
        payload.Description = description!;
        payload.PHQID = questionnaire?.PhqSelected?.PHQID;
        payload.CreatedBy = authContext.logInfo?.UserID;
        payload.Status = 'Published';
        payload.IsPublished = true;
        // payload.RawPHQ = JSON.stringify(appContext.questionnaire.PhqSelected); - this should be on backend
        // payload.BaseVersionID = appContext.questionnaire.PhqSelected.PublishedPHQVersionID;
        createNewVersion(payload)
        .then(res => {
            notifySuccess('Form Published!');
            const result = res?.data?.result as PHQVersion;
            const phq = questionnaire.PhqSelected;
            // phq.PublishedPHQVersionID = result.PHQVersionID
            if (phq && phq.Versions?.length! > 0) {
                phq.Versions?.map(f => f.Status === 'Active');
                phq.Versions?.push(result);
            }
            else {
                phq.Versions = [result];
            }
            updateQuestionnaire(QuestionnaireActionTypes.PHQ_SELECTED, phq)
            props.fnToHideForm(true)
        })
        .finally(() => setIsLoading(false))
    }

    return (
        <React.Fragment>
            <IonCard className="mx-0 my-2">
                <IonCardHeader color="primary">
                    <IonToolbar color="primary">
                        <IonCardTitle className="ion-text-center">
                            <h3 className="ion-text-center">Publish Version</h3>
                        </IonCardTitle>
                    </IonToolbar>
                </IonCardHeader>
                <IonCardContent>
                    <form>
                        <IonItem>
                            <IonLabel position="floating">Description</IonLabel>
                            <IonInput value={description} onIonChange={(e) => { setDescription(e?.detail?.value!) }} type="text"></IonInput>
                        </IonItem>
                    </form>
                    <div className="d-flex justify-content-center mt-2">
                        <IonButton onClick={() => props.fnToHideForm(false)}>Close</IonButton>
                        <IonButton disabled={!description} color="success" onClick={() => publishVersion()}>Publish</IonButton>
                    </div>
                </IonCardContent>
            </IonCard>
        </React.Fragment >
    );
};
export default PHQPublishVersionForm;
